export const FETCH_PREMIUM_OFFERS_SHOP =
  "premiumOffersShop/FETCH_PREMIUM_OFFERS_SHOP";
export type FETCH_PREMIUM_OFFERS_SHOP = typeof FETCH_PREMIUM_OFFERS_SHOP;

export const SET_PREMIUM_OFFERS_SHOP_RESULTS =
  "premiumOffersShop/SET_PREMIUM_OFFERS_SHOP_RESULTS";
export type SET_PREMIUM_OFFERS_SHOP_RESULTS =
  typeof SET_PREMIUM_OFFERS_SHOP_RESULTS;

export const SET_OFFERS_SORT = "premiumOffersShop/SET_OFFERS_SORT";
export type SET_OFFERS_SORT = typeof SET_OFFERS_SORT;

export const SET_IS_USER_TRIGGERED_SEARCH =
  "premiumOffersShop/SET_IS_USER_TRIGGERED_SEARCH";
export type SET_IS_USER_TRIGGERED_SEARCH =
  typeof SET_IS_USER_TRIGGERED_SEARCH;

export const SET_FILTER_CATEGORY_VALUE =
  "premiumOffersShop/SET_FILTER_CATEGORY_VALUE";
export type SET_FILTER_CATEGORY_VALUE = typeof SET_FILTER_CATEGORY_VALUE;
